export const alertWrapper = (alertInfo, openAlertDialog, shouldOpenAlert) => {
  if (shouldOpenAlert) {
    openAlertDialog(alertInfo);
  } else {
    alertInfo.onAgree();
  }
};
